module.exports = __webpack_public_path__ + "img/gif.00fdd9bd.svg";